import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { getTokenValue } from "@tamagui/core";
import { Box } from "../Box";
import { Button } from "../Button";
import { SimpleCheckbox } from "../inputs";
import { jsx, jsxs } from "react/jsx-runtime";
const { dialog: dialogTokens } = tokens, Container = ({ children, $largerThanSM, ...props }) => /* @__PURE__ */ jsx(
  Box,
  {
    marginTop: -1 * getTokenValue(dialogTokens.margin.mobile.bottom),
    $largerThanSM: {
      marginTop: -1 * getTokenValue(dialogTokens.margin.desktop.bottom),
      ...$largerThanSM
    },
    ...props,
    children
  }
), ButtonContainer = ({ children, buttonPosition }) => /* @__PURE__ */ jsx(
  Box,
  {
    paddingTop: dialogTokens.padding.mobile.betweenElements,
    paddingBottom: dialogTokens.margin.mobile.bottom,
    paddingHorizontal: dialogTokens.margin.mobile.leftRight,
    $largerThanSM: {
      paddingBottom: dialogTokens.margin.desktop.bottom,
      paddingHorizontal: dialogTokens.margin.desktop.leftRight,
      flexDirection: buttonPosition === "stacked" ? "column" : "row"
    },
    gap: dialogTokens.padding.actions.default,
    children
  }
), Actions = ({
  buttonPosition,
  buttonOneProps,
  buttonTwoProps,
  checkboxProps,
  ...props
}) => /* @__PURE__ */ jsxs(Container, { ...props, children: [
  checkboxProps && /* @__PURE__ */ jsx(
    Box,
    {
      paddingTop: dialogTokens.margin.mobile.top,
      paddingHorizontal: dialogTokens.margin.mobile.leftRight,
      $largerThanSM: {
        paddingTop: 0,
        paddingHorizontal: dialogTokens.margin.desktop.leftRight
      },
      children: /* @__PURE__ */ jsx(SimpleCheckbox, { ...checkboxProps })
    }
  ),
  /* @__PURE__ */ jsxs(ButtonContainer, { buttonPosition, children: [
    buttonOneProps && /* @__PURE__ */ jsx(
      Button,
      {
        variant: "primary",
        size: "small",
        $largerThanSM: { size: "medium", flexGrow: 1 },
        ...buttonOneProps
      }
    ),
    buttonTwoProps && /* @__PURE__ */ jsx(
      Button,
      {
        variant: "secondary",
        size: "small",
        $largerThanSM: { size: "medium", flexGrow: 1 },
        ...buttonTwoProps
      }
    )
  ] })
] });
export {
  Actions
};
